import { connect } from 'react-redux';
import openProbeDetails from '../../../../api/probeDetails/probeDetailsActions';
import { selectors } from '../../../../root/reading/root';
import ProgressTable from '../../../../features/progress/shared/progressReview/ProgressTable';
import { openBasicComprehensionWebEntry } from '../../../../api/basicComprehensionWebEntry/shared/basicComprehensionWebEntryActions';
import ProbeDetailsPageContainer from '../../../probeDetails/reading/ProbeDetailsPageContainer';
import { getRowsToRender } from '../../../../utils/reading/pmUtils';

const mapStateToProps = state => ({
    location: selectors.getLocation(state),
    pmPeriod: selectors.getSelectedPmPeriod(state),
    windowDates: selectors.getWindowDates(state),
    resultsByGrades: selectors.getStudentsPmDataByGrades(state),
    interventionsByPmPeriods: selectors.getInterventions(state),
    areResultsUpdating: selectors.areResultsUpdating(state),
    getGradeToMeasureMapper: selectors.getGradeToMeasureMapper(state),
    ProbeDetailsPageContainer,
    getRowsToRender,
});

const mapDispatchToProps = dispatch => ({
    openProbeDetails: resultId => dispatch(openProbeDetails(resultId)),
    openBasicComprehensionWebEntry: () => dispatch(openBasicComprehensionWebEntry(true)),
});

const mergeProps = (stateProps, dispatchProps, ownProps) => {
    const { colSpans, rowSpans } = getRowsToRender({
        resultsByGrades: stateProps.resultsByGrades,
        pmPeriod: stateProps.pmPeriod,
        windowDates: stateProps.windowDates,
        location: stateProps.location,
        openMazeWebEntry: dispatchProps.openBasicComprehensionWebEntry,
        openProbeDetails: dispatchProps.openProbeDetails,
        withIntervention: ownProps.withIntervention,
        interventionsByPmPeriods: stateProps.interventionsByPmPeriods,
        getGradeToMeasureMapper: stateProps.getGradeToMeasureMapper,
    });
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        colSpans,
        rowSpans,
    };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(ProgressTable);
